import { ElementRef } from '@angular/core';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { CUSTOMIZE_PAGES_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "AccountsApp/ts/services/accounts.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i5 from "@angular/forms";
function PerformanceIncludeBenchmarkCheckboxComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 1)(1, "input", 2);
    i0.ɵɵtwoWayListener("ngModelChange", function PerformanceIncludeBenchmarkCheckboxComponent_label_0_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.benchmarkSelected, $event) || (ctx_r1.benchmarkSelected = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function PerformanceIncludeBenchmarkCheckboxComponent_label_0_Template_input_ngModelChange_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleBenchmark()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 3);
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4, "Show Benchmark Comparison");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.benchmarkSelected);
} }
export class PerformanceIncludeBenchmarkCheckboxComponent {
    constructor(featureService, accountsService, eltRef) {
        this.featureService = featureService;
        this.accountsService = accountsService;
        this.eltRef = eltRef;
        this.userPreferenceKeys = {};
        this.benchmarkSelected = false;
        this.benchmarkDisabled = false;
        this.USER = window.USER;
        this.userPreferenceKeys = JSON.parse(eltRef.nativeElement.getAttribute('userPreferenceKeys'));
        this.benchmarkDisabled = JSON.parse(eltRef.nativeElement.getAttribute('benchmarkDisabled'));
    }
    ngOnInit() {
        if (this.benchmarkDisabled) {
            this.benchmarkSelected = false;
        }
        else {
            this.accountsService.getUserPreferences().subscribe({
                next: (preferences) => {
                    this.benchmarkSelected =
                        preferences[this.userPreferenceKeys.include_benchmark];
                },
                error: () => { },
            });
        }
    }
    toggleBenchmark() {
        if (!this.featureService.userHasFeatures([CUSTOMIZE_PAGES_FEATURE])) {
            this.featureNeededComponent.openModal(CUSTOMIZE_PAGES_FEATURE);
        }
        if (this.USER.authenticated && this.userPreferenceKeys?.include_benchmark != null) {
            const benchmarkPreferenceParams = {
                [this.userPreferenceKeys.include_benchmark]: this.benchmarkSelected,
            };
            this.accountsService.putUserPreferences(benchmarkPreferenceParams).subscribe({
                next: () => window.location.reload(),
                error: () => { },
            });
        }
    }
}
PerformanceIncludeBenchmarkCheckboxComponent.ɵfac = function PerformanceIncludeBenchmarkCheckboxComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PerformanceIncludeBenchmarkCheckboxComponent)(i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.AccountsService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
PerformanceIncludeBenchmarkCheckboxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PerformanceIncludeBenchmarkCheckboxComponent, selectors: [["ycn-performance-include-benchmark-checkbox"]], viewQuery: function PerformanceIncludeBenchmarkCheckboxComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, inputs: { userPreferenceKeys: "userPreferenceKeys" }, standalone: false, decls: 2, vars: 1, consts: [["class", "custom-control custom-checkbox", 4, "ngIf"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function PerformanceIncludeBenchmarkCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PerformanceIncludeBenchmarkCheckboxComponent_label_0_Template, 5, 1, "label", 0);
        i0.ɵɵelement(1, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.benchmarkDisabled);
    } }, dependencies: [i3.NgIf, i4.FeatureNeededComponent, i5.CheckboxControlValueAccessor, i5.NgControlStatus, i5.NgModel], encapsulation: 2 });
